import { WhatsAppGlyph } from "./CardShell";

export default function ContactFooter({ contact, cta }) {
  return (
    <footer className="mc-foot">
      <div className="mc-cta">
        <WhatsAppGlyph />
        <span>{cta}</span>
      </div>
      <div className="mc-contact" data-testid="card-contact">
        <div className="mc-contact-salon">{contact.salon || "Agent vânzări Medavita"}</div>
        {contact.whatsapp ? <div>Tel. {contact.whatsapp}</div> : <div className="mc-phone-blank">Tel.</div>}
      </div>
    </footer>
  );
}
